import type { ComponentPropsWithRef, ReactNode } from "react";
import { cn } from "@/lib/utils";
import {
  type FieldSize,
  areaChrome,
  inlineAreaChrome,
  inlineLineAreaChrome,
} from "./field-chrome";

interface Chrome {
  size?: FieldSize;
  /**
   * Boxed for a form; inline for words drawn as themselves until pointed at; line for a line
   * edited in place, as an inline Input draws it, that wraps when its words run long.
   */
  appearance?: "boxed" | "inline" | "line";
  children?: ReactNode;
}

export type TextareaProps = Chrome &
  Omit<ComponentPropsWithRef<"textarea">, keyof Chrome>;

/**
 * The field an attorney writes into.
 *
 * No minimum height of its own: what a claim, a note and a walk-through each
 * need is different, and the one that was set here was overridden at every
 * site that cared.
 */
export function Textarea({
  size,
  appearance = "boxed",
  className,
  ...rest
}: TextareaProps) {
  return (
    <textarea
      className={cn(
        appearance === "inline"
          ? inlineAreaChrome()
          : appearance === "line"
            ? inlineLineAreaChrome()
            : areaChrome(size),
        className,
      )}
      {...rest}
    />
  );
}
